export default __webpack_public_path__ + "static/media/released.abb3cb67.svg";